import { ReactNode } from 'react';
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import MouseOutlinedIcon from '@mui/icons-material/MouseOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import DesktopMacOutlinedIcon from '@mui/icons-material/DesktopMacOutlined';
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { messages } from 'src/locales/messages';
import SlowMotionVideoOutlinedIcon from '@mui/icons-material/SlowMotionVideoOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import VideoSettingsOutlinedIcon from '@mui/icons-material/VideoSettingsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import CropSquareOutlinedIcon from '@mui/icons-material/CropSquareOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import { UserRoles } from 'src/utils/constants';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import ScreenSearchDesktopOutlinedIcon from '@mui/icons-material/ScreenSearchDesktopOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  name: any;
  roles?: string[];
}

export interface MenuItems {
  items: MenuItem[];
  heading: any;
  collapseHeader?: boolean;
}

const admin = UserRoles.toString(UserRoles.Admin);
const mirror = UserRoles.toString(UserRoles.Mirrors_owner);
const ar_owner_namecard = UserRoles.toString(UserRoles.AR_owner_namecard);
const ar_owner_pamphlet = UserRoles.toString(UserRoles.AR_owner_pamphlet);
const ar_admin = UserRoles.toString(UserRoles.AR_admin);
const user_admin = UserRoles.toString(UserRoles.User_admin);
const mirror_viewer = UserRoles.toString(UserRoles.Mirror_viewer);

export const menuItems: MenuItems[] = [
  {
    heading: messages.sidebar.analytics,
    items: [
      {
        name: messages.sidebar.peopleCounter,
        icon: AnalyticsOutlinedIcon,
        roles: [admin, mirror, mirror_viewer],
        items: [
          {
            name: messages.sidebar.data,
            icon: FeedOutlinedIcon,
            link: 'people-counter/detailed',
            roles: [admin, mirror, mirror_viewer]
          },
          {
            name: messages.sidebar.chart,
            icon: EqualizerOutlinedIcon,
            link: 'people-counter/summary',
            roles: [admin, mirror, mirror_viewer]
          }
        ]
      },
      {
        name: messages.sidebar.clickTracking,
        icon: MouseOutlinedIcon,
        roles: [admin, mirror, mirror_viewer],
        items: [
          {
            name: messages.sidebar.data,
            icon: FeedOutlinedIcon,
            link: 'user-click-tracking',
            roles: [admin, mirror, mirror_viewer]
          },
          {
            name: messages.sidebar.chart,
            icon: EqualizerOutlinedIcon,
            link: 'chart-user-click-tracking',
            roles: [admin, mirror, mirror_viewer]
          }
        ]
      },
      {
        name: messages.sidebar.survey,
        icon: QuestionAnswerOutlinedIcon,
        link: 'survey',
        roles: [admin, mirror, mirror_viewer],
        items: [
          {
            name: messages.sidebar.data,
            icon: FeedOutlinedIcon,
            link: 'survey',
            roles: [admin, mirror, mirror_viewer]
          },
          {
            name: messages.sidebar.chart,
            icon: EqualizerOutlinedIcon,
            link: 'chart-survey',
            roles: [admin, mirror, mirror_viewer]
          }
        ]
      }
    ]
  },
  {
    heading: messages.sidebar.bigMirrors,
    items: [
      {
        name: messages.sidebar.categories,
        icon: CategoryOutlinedIcon,
        roles: [admin, mirror, mirror_viewer],
        items: [
          {
            name: messages.sidebar.snapList,
            icon: ViewModuleOutlinedIcon,
            link: 'snaps',
            roles: [admin]
          },
          {
            name: messages.sidebar.contentList,
            icon: SportsEsportsOutlinedIcon,
            link: 'contents',
            roles: [admin]
          },
          {
            name: messages.sidebar.mirrorType,
            icon: DesktopMacOutlinedIcon,
            link: 'mirror-types',
            roles: [admin, mirror, mirror_viewer]
          },
          {
            name: messages.sidebar.videosList,
            icon: VideoSettingsOutlinedIcon,
            link: 'videos',
            roles: [admin]
          },
          {
            name: messages.sidebar.bannerList,
            icon: QrCode2OutlinedIcon,
            link: 'qr-images',
            roles: [admin]
          }
        ]
      },
      {
        name: messages.sidebar.setupMirrors,
        icon: SettingsApplicationsOutlinedIcon,
        roles: [admin, mirror, mirror_viewer],
        items: [
          {
            name: messages.sidebar.mirrors,
            icon: VideoSettingsOutlinedIcon,
            link: 'mirrors',
            roles: [admin, mirror, mirror_viewer]
          },
          {
            name: messages.sidebar.profiles,
            icon: MiscellaneousServicesOutlinedIcon,
            link: 'profiles',
            roles: [admin]
          }
        ]
      }
    ]
  },
  {
    heading: messages.sidebar.ARProjects,
    items: [
      {
        name: messages.sidebar.arMasterTemplates,
        icon: ListAltOutlinedIcon,
        link: 'ar-templates',
        roles: [admin, ar_admin, ar_owner_namecard, ar_owner_pamphlet]
      },
      {
        name: messages.sidebar.arNameCard,
        icon: AccountTreeOutlinedIcon,
        link: 'ar-namecard',
        roles: [admin, ar_owner_namecard, ar_admin]
      },
      {
        name: messages.sidebar.arPamphlet,
        icon: AutoAwesomeMotionOutlinedIcon,
        link: 'ar-pamphlet',
        roles: [ar_admin, admin, ar_owner_pamphlet]
      },
      {
        name: messages.sidebar.arPreview,
        icon: SlowMotionVideoOutlinedIcon,
        link: 'ar-preview',
        roles: [ar_admin, admin]
      },
      {
        name: messages.sidebar.monitoring,
        icon: ScreenSearchDesktopOutlinedIcon,
        roles: [ar_admin, admin],
        items: [
          {
            name: messages.sidebar.arScanNamecard,
            icon: ManageSearchOutlinedIcon,
            link: 'ar-namecard/scan-statictis',
            roles: [ar_admin, admin]
          },
          {
            name: messages.sidebar.arScanPamphlet,
            icon: ManageSearchOutlinedIcon,
            link: 'ar-pamphlet/scan-statictis',
            roles: [ar_admin, admin]
          }
        ]
      }
    ]
  },
  {
    heading: messages.sidebar.audit,
    items: [
      {
        name: messages.sidebar.audit,
        icon: ManageSearchOutlinedIcon,
        roles: [admin, user_admin, ar_admin],
        items: [
          {
            name: messages.sidebar.arProjects,
            icon: AccountTreeOutlinedIcon,
            link: 'ar-project-audit',
            roles: [admin, user_admin, ar_admin]
          },
          {
            name: messages.sidebar.userList,
            icon: ContactPageOutlinedIcon,
            link: 'user-audit',
            roles: [admin, user_admin, ar_admin]
          },
          {
            name: messages.sidebar.profiles,
            icon: BadgeOutlinedIcon,
            link: 'profile-audit',
            roles: [admin, user_admin, ar_admin]
          },
          {
            name: messages.sidebar.mirrors,
            icon: CropSquareOutlinedIcon,
            link: 'mirror-audit',
            roles: [admin, user_admin, ar_admin]
          }
        ]
      }
    ]
  },
  {
    heading: messages.sidebar.userManagement,
    items: [
      {
        name: messages.sidebar.userManagement,
        icon: ManageAccountsOutlinedIcon,
        roles: [admin, user_admin],
        items: [
          {
            name: messages.sidebar.userList,
            icon: ManageAccountsOutlinedIcon,
            roles: [admin, user_admin],
            link: 'users-management'
          },
          {
            name: messages.sidebar.groupList,
            icon: GroupsOutlinedIcon,
            roles: [admin, user_admin],
            link: 'group-list'
          }
        ]
      }
    ]
  },
  {
    heading: messages.sidebar.quiz,
    items: [
      {
        name: messages.sidebar.quiz,
        icon: HelpOutlineOutlinedIcon,
        roles: [admin, ar_admin],
        link: 'quiz'
      }
    ]
  },
];
